import http from "./httpService";
import urlConstant from "../constants/url-constants";

export async function getOnlineNews() {
    return http.get(urlConstant.getNewsEndpoint(), http.getPublicConfig());
}

export async function getOnlineNewsById(id) {
    return http.post(urlConstant.getNewsEndpointById(), {
        id
    }, http.getPublicConfig());
}

export default {
    getOnlineNews,
    getOnlineNewsById
};

